import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

/**
 * Pipe para formatear números usando la configuración regional española (`es-ES`).
 * 
 * Utiliza `Intl.NumberFormat` para aplicar formato de número con las opciones
 * que se le pasen, como cantidad de decimales, uso de separadores, etc.
 * 
 * Ejemplo de uso en template:
 * ```html
 * {{ 1234567.89 | formatNumberEs:{ minimumFractionDigits: 2 } }}
 * ```
 * Resultado: `"1.234.567,89"`
 */
@Pipe({
  name: 'formatNumberEs'
})
export class FormatNumberEsPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) { }

  /**
   * Transforma un número a formato local español según las opciones indicadas.
   * 
   * @param value Número a formatear.
   * @param options Opciones de formateo compatibles con Intl.NumberFormat.
   * @returns Cadena con el número formateado o cadena vacía si el valor es null o undefined.
   */
  transform(value: number | undefined, options?: Intl.NumberFormatOptions): string {
    if (value === null || value === undefined) return '';
    return new Intl.NumberFormat('es-ES', options).format(value);
  }
}
